var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlignVertically(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4 20H6.6C4.68 20 3.75 19.02 3.75 17.02V15.98C3.75 13.98 4.68 13 6.6 13H17.4C19.32 13 20.25 13.98 20.25 15.98V17.02C20.25 19.02 19.32 20 17.4 20ZM6.6 14.5C5.59 14.5 5.25 14.71 5.25 15.98V17.02C5.25 18.29 5.59 18.5 6.6 18.5H17.4C18.41 18.5 18.75 18.29 18.75 17.02V15.98C18.75 14.71 18.41 14.5 17.4 14.5H6.6Z",
    fill: "#0C1525"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4 11.5H8.6C6.68 11.5 5.75 10.52 5.75 8.52V7.48C5.75 5.47 6.68 4.5 8.6 4.5H15.4C17.32 4.5 18.25 5.48 18.25 7.48V8.52C18.25 10.52 17.32 11.5 15.4 11.5ZM8.6 6C7.59 6 7.25 6.21 7.25 7.48V8.52C7.25 9.79 7.59 10 8.6 10H15.4C16.41 10 16.75 9.79 16.75 8.52V7.48C16.75 6.21 16.41 6 15.4 6H8.6Z",
    fill: "#0C1525"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.75C11.59 22.75 11.25 22.41 11.25 22V19.6C11.25 19.19 11.59 18.85 12 18.85C12.41 18.85 12.75 19.19 12.75 19.6V22C12.75 22.41 12.41 22.75 12 22.75Z",
    fill: "#0C1525"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.75C11.59 13.75 11.25 13.41 11.25 13V11C11.25 10.59 11.59 10.25 12 10.25C12.41 10.25 12.75 10.59 12.75 11V13C12.75 13.41 12.41 13.75 12 13.75Z",
    fill: "#0C1525"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.44C11.59 5.44 11.25 5.1 11.25 4.69V2C11.25 1.59 11.59 1.25 12 1.25C12.41 1.25 12.75 1.58 12.75 2V4.69C12.75 5.11 12.41 5.44 12 5.44Z",
    fill: "#0C1525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignVertically);
export default __webpack_public_path__ + "static/media/align-vertically.e9820e241389743f80cae0ef7b0aa1ab.svg";
export { ForwardRef as ReactComponent };